export default __webpack_public_path__ + "static/media/image-pocket-borealis.0b89db1f.jpg";